import React, { useState } from 'react';
import FiyatTablosu from '../components/fiyat_tablo';
import TradingView from '../components/tradingview';
import Mob from '../components/mob';
import AraHakkimizda from '../components/ara_hakkimizda';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import '../@style/HomePage.css';

const MilyemPage = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();
  const [selectedSymbol, setSelectedSymbol] = useState('XAUTRY');

  const handleSymbolSelect = (symbol) => {
    setSelectedSymbol(symbol);
  };

  return (
    <div className={`home-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <section className="info-banner">
        <div className="container">
          <div className="banner-content">
            <span>{t('home.price_info')}</span>
          </div>
        </div>
      </section>

      <FiyatTablosu mode="milyem" onSymbolSelect={handleSymbolSelect} />

      <section className="tradingview-section">
        <div className="container">
          <TradingView selectedSymbol={selectedSymbol} />
        </div>
      </section>

      <Mob />
      <AraHakkimizda />
    </div>
  );
};

export default MilyemPage;
